import type { PageErrorProps } from "./page-error.type";

import { Typography, Button } from "antd";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";

import "./page-error.style.less";

const { Title } = Typography;

const PageError = ({ status, isAuth }: PageErrorProps) => {
  const { t } = useTranslation();
  const location = useLocation();

  const is404 = status === 404;
  const translationKey = is404 ? "notFound" : "default";
  const translationBase = `navigation:pageError:${translationKey}`;

  return (
    <div className="page-error">
      <Title>{t(`${translationBase}.title`)}</Title>
      {is404 && (
        <p>
          {t(`${translationBase}.description`, { path: location.pathname })}
        </p>
      )}
      {isAuth ? (
        <Link to="/auth/login">
          <Button type="primary">
            {t("navigation:pageError:returnToLogin")}
          </Button>
        </Link>
      ) : (
        <Link to="/">
          <Button type="primary">
            {t("navigation:pageError:returnToDashboard")}
          </Button>
        </Link>
      )}
    </div>
  );
};

export default PageError;
